import {CrudRightsEnum} from "../../../enums/user/crud-rights.enum";
import {UserTypeEnum} from "../../../enums/user/user-type.enum";

export interface UserModelInterface {
  [key: string]: string | number | UserTypeEnum | CrudRightsEnum | undefined;

  /* Short code of a TRUMPF organization
  the user should have access to all assets
  from all customers assigned to the TRUMPF company.*/
  companyId: string;

  /* A custom identifier for the access right.*/
  type: UserTypeEnum;

  /* Flags for CRUD rights which can be bitwise combined.*/
  crudRights: CrudRightsEnum;

  /* CRUD rights label for display purposes*/
  crudRightsText?: string;

  id: number;

  /* User ID.
  From AD for TRUMPF users.
  From C-IDM for MyTRUMPF users.*/
  userId: string;

  changedBy: string;

  changedTimestamp: string;
}

export class UserModel implements UserModelInterface {
  [key: string]: string | number | UserTypeEnum | CrudRightsEnum | undefined;

  public companyId = "";
  public type = UserTypeEnum.All_Assets; // Default to AT, will be overridden by factory method
  public crudRights = CrudRightsEnum.None;
  public crudRightsText?: string = "";
  public id = -1;
  public userId = "";
  public changedBy = "";
  public changedTimestamp = "";

  /**
   * Factory method to create a UserModel with automatic type assignment
   * based on companyId presence and appropriate default crud rights
   */
  public static create(
    userId: string,
    companyId: string = "",
    crudRights?: CrudRightsEnum,
    id: number = -1,
    changedBy: string = "",
    changedTimestamp: string = ""
  ): UserModel {
    const user = new UserModel();
    user.userId = userId;
    user.id = id;
    user.changedBy = changedBy;
    user.changedTimestamp = changedTimestamp;

    if (companyId && companyId.trim() !== "") {
      user.type = UserTypeEnum.Company_Assets;
      user.companyId = companyId;

      user.crudRights = crudRights !== undefined ? crudRights : CrudRightsEnum.Read;
    } else {
      user.type = UserTypeEnum.All_Assets;
      user.companyId = "";
      user.crudRights = crudRights !== undefined ? crudRights : CrudRightsEnum.None;
    }

    return user;
  }
}
